export const RESET = 'INTERNALANNOUNCEMENT_UPDATE_RESET'
export const SET_ERROR = 'INTERNALANNOUNCEMENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'INTERNALANNOUNCEMENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'INTERNALANNOUNCEMENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'INTERNALANNOUNCEMENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'INTERNALANNOUNCEMENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'INTERNALANNOUNCEMENT_UPDATE_UPDATE_RETRIEVED'
